/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface DataFetchConfig
 */
export interface DataFetchConfig {
  /**
   * A list of additional headers to be added to the input fetch request when using http or https. This is intended to support authentication or authorization, for example by supplying an OAuth2 bearer token.
   * @type {Array<string>}
   * @memberof DataFetchConfig
   */
  auth_headers?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof DataFetchConfig
   */
  url: string;
}
